// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","266":"dffca5a6","513":"2651e520","706":"711ede07","726":"2b58ec26","880":"e4c2a086"}[chunkId] + ".chunk.js";
};